var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationSignups2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 189 215"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "illustration_signups_2_svg__cls-1",
    cx: 87.72,
    cy: 103,
    rx: 69.75,
    ry: 70
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-2",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M79.65 117.6a6.92 6.92 0 01-10.48 0 8.82 8.82 0 010-11.58l4.18-4.62a6.92 6.92 0 0110.48 0 8.82 8.82 0 010 11.58zM186.8 44.66a7.17 7.17 0 01-10.6 0 8.39 8.39 0 010-11.32 7.17 7.17 0 0110.6 0 8.39 8.39 0 010 11.32zm-66.09 73a7.06 7.06 0 01-10.51 0 8.5 8.5 0 010-11.36l10-10.85a8.5 8.5 0 000-11.36 7.06 7.06 0 00-10.51 0l-10 10.85a7 7 0 01-10.5 0 8.49 8.49 0 010-11.35l2.19-2.38a8.5 8.5 0 000-11.36 7 7 0 00-10.5 0l-2.21 2.38a7 7 0 01-10.49 0 8.48 8.48 0 010-11.36l54.11-58.5a7.06 7.06 0 0110.51 0 8.5 8.5 0 010 11.35l-13.29 14.35a8.5 8.5 0 000 11.36 7 7 0 0010.51 0l13.29-14.37a7 7 0 0110.5 0 8.5 8.5 0 010 11.36l-5.45 5.89a8.5 8.5 0 000 11.36 7.06 7.06 0 0010.51 0l5.45-5.89a7 7 0 0110.5 0 8.48 8.48 0 010 11.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-3",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M13.65 207.6a6.92 6.92 0 01-10.48 0 8.82 8.82 0 010-11.58l4.18-4.62a6.92 6.92 0 0110.48 0 8.82 8.82 0 010 11.58zm107-72.75a7.16 7.16 0 01-10.41-.19 8.39 8.39 0 010-11.32 7.17 7.17 0 0110.6 0 8.39 8.39 0 010 11.32zm-65.9 72.8a7.06 7.06 0 01-10.51 0 8.5 8.5 0 010-11.36l10-10.85a8.5 8.5 0 000-11.36 7.06 7.06 0 00-10.51 0l-10 10.85a7 7 0 01-10.5 0 8.49 8.49 0 010-11.35l2.19-2.38a8.5 8.5 0 000-11.36 7 7 0 00-10.5 0l-2.21 2.38a7 7 0 01-10.49 0 8.48 8.48 0 010-11.36l54.11-58.5a7.06 7.06 0 0110.51 0 8.5 8.5 0 010 11.35l-13.33 14.36a8.5 8.5 0 000 11.36 7 7 0 0010.51 0l13.29-14.37a7 7 0 0110.5 0 8.5 8.5 0 010 11.36l-5.45 5.89a8.5 8.5 0 000 11.36 7.06 7.06 0 0010.51 0l5.45-5.89a7 7 0 0110.5 0 8.48 8.48 0 010 11.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-4",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "illustration_signups_2_svg__cls-1",
    x: 12.54,
    y: 44,
    width: 145.01,
    height: 118,
    rx: 6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-5",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "illustration_signups_2_svg__cls-1",
    x: 16.54,
    y: 47.99,
    width: 137.02,
    height: 110.01,
    rx: 3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-6",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M10.96 37h148v133h-148z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-7",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M15.96 47h138v112h-138z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-8",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M101.9 47h52.07v112H101.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-9",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M92.96 32h84v179h-84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-10",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M100.96 47h53v112h-53z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-11",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M130.29 74.71a6.92 6.92 0 018-6.74 8.81 8.81 0 017.44 8.87l-.23 6.23a6.93 6.93 0 01-8 6.74 8.81 8.81 0 01-7.44-8.87zM95 200.6a7.16 7.16 0 018.1-6.54 8.38 8.38 0 017.28 8.66 7.18 7.18 0 01-8.13 6.82 8.38 8.38 0 01-7.25-8.67zm3.08-98.87a7.18 7.18 0 018.2-6.87 8.63 8.63 0 017.42 8.84l-.73 15a8.62 8.62 0 007.42 8.85 7.17 7.17 0 008.19-6.88l.74-15a7.17 7.17 0 018.19-6.87 8.64 8.64 0 017.43 8.84l-.17 3.29a8.63 8.63 0 007.43 8.84 7.17 7.17 0 008.19-6.87l.16-3.3a7.18 7.18 0 018.2-6.86 8.64 8.64 0 017.42 8.85l-4 81a7.17 7.17 0 01-8.19 6.87 8.63 8.63 0 01-7.43-8.83l1-19.89a8.63 8.63 0 00-7.43-8.85 7.17 7.17 0 00-8.19 6.87l-1 19.89a7.18 7.18 0 01-8.2 6.87 8.63 8.63 0 01-7.42-8.84l.4-8.16a8.63 8.63 0 00-7.43-8.84 7.17 7.17 0 00-8.19 6.87l-.4 8.15a7.18 7.18 0 01-8.19 6.88 8.64 8.64 0 01-7.43-8.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-13",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M16.54 47.99h137.02v5.24H16.54z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-14",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "illustration_signups_2_svg__cls-1",
    cx: 21.4,
    cy: 50.61,
    r: 1.12,
    transform: "rotate(-89.87 21.407 50.618)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-16",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "illustration_signups_2_svg__cls-1",
    cx: 25.9,
    cy: 50.61,
    r: 1.12,
    transform: "rotate(-.13 26.39 48.511)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-18",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "illustration_signups_2_svg__cls-1",
    cx: 30.39,
    cy: 50.61,
    r: 1.12,
    transform: "rotate(-.15 30.493 49.696)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-20",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M40.16 137.16H68a3.58 3.58 0 010 7.16H40.16a3.58 3.58 0 010-7.16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-21",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M28.24 71.22a3.58 3.58 0 10-3.57-3.58 3.58 3.58 0 003.57 3.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-22",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "illustration_signups_2_svg__cls-1",
    x: 36.58,
    y: 73.6,
    width: 40.52,
    height: 7.15,
    rx: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-23",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M37 65.66h29.4a1.19 1.19 0 010 2.38H37a1.19 1.19 0 010-2.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-24",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M37 88.7h29.4a1.19 1.19 0 010 2.38H37a1.19 1.19 0 010-2.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-25",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M37 114.12h29.4a1.2 1.2 0 010 2.39H37a1.2 1.2 0 010-2.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-26",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "illustration_signups_2_svg__cls-1",
    x: 36.58,
    y: 97.44,
    width: 40.52,
    height: 7.15,
    rx: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-27",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "illustration_signups_2_svg__cls-1",
    x: 36.58,
    y: 120.48,
    width: 40.52,
    height: 7.15,
    rx: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-28",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "illustration_signups_2_svg__cls-1",
    cx: 85.96,
    cy: 174,
    r: 23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-29",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M84.25 181a1.14 1.14 0 00.83-.35l1.67-1.72 8.87-9.14a1.26 1.26 0 000-1.72L94 166.35a1.11 1.11 0 00-.83-.35 1.13 1.13 0 00-.83.35l-8 8.3-3.61-3.73a1.13 1.13 0 00-.83-.35 1.11 1.11 0 00-.83.35l-1.67 1.72a1.23 1.23 0 000 1.72l6.1 6.29a1.15 1.15 0 00.75.35z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-35",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M10.96 42h148v122h-148z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-37",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M97.96 53h56v105h-56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-38",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-1",
    d: "M89.96 48h90v149h-90z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-40",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M91.43 108.09l8.74 80.59a8.64 8.64 0 008.72 7.58 7.17 7.17 0 007-8.07l-.88-8.12a7.18 7.18 0 017-8.07 8.64 8.64 0 018.72 7.58l.88 8.12a8.63 8.63 0 008.71 7.57 7.17 7.17 0 007-8.07l-2.15-19.8a7.18 7.18 0 017-8.07 8.64 8.64 0 018.72 7.58l2.15 19.8a8.62 8.62 0 008.71 7.56 7.17 7.17 0 007-8.07L170 105.61a8.63 8.63 0 00-8.62-7.61 7.18 7.18 0 00-7 8.06l.35 3.28a7.17 7.17 0 01-7 8.07 8.62 8.62 0 01-8.71-7.57l-.36-3.28a8.63 8.63 0 00-8.75-7.56 7.18 7.18 0 00-7 8.07l1.62 15a7.17 7.17 0 01-7 8.07 8.64 8.64 0 01-8.72-7.58l-1.62-14.94a8.63 8.63 0 00-8.75-7.62 7.17 7.17 0 00-7 8.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration_signups_2_svg__clip-path-42",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-2",
    d: "M116.93 77l.75 6.2a8.81 8.81 0 008.74 7.59 6.91 6.91 0 006.87-7.9l-.74-6.2a8.81 8.81 0 00-8.74-7.59 6.92 6.92 0 00-6.88 7.9"
  })), /*#__PURE__*/React.createElement("style", null, ".illustration_signups_2_svg__cls-1,.illustration_signups_2_svg__cls-2{fill:none}.illustration_signups_2_svg__cls-2{clip-rule:evenodd}.illustration_signups_2_svg__cls-4{clip-path:url(#illustration_signups_2_svg__clip-path)}.illustration_signups_2_svg__cls-5{fill:#7d32ff}.illustration_signups_2_svg__cls-6{clip-path:url(#illustration_signups_2_svg__clip-path-2)}.illustration_signups_2_svg__cls-7{fill:#ffe436}.illustration_signups_2_svg__cls-8{clip-path:url(#illustration_signups_2_svg__clip-path-3)}.illustration_signups_2_svg__cls-9{clip-path:url(#illustration_signups_2_svg__clip-path-4)}.illustration_signups_2_svg__cls-10{fill:#410186}.illustration_signups_2_svg__cls-11{clip-path:url(#illustration_signups_2_svg__clip-path-5)}.illustration_signups_2_svg__cls-12{isolation:isolate}.illustration_signups_2_svg__cls-14{clip-path:url(#illustration_signups_2_svg__clip-path-7)}.illustration_signups_2_svg__cls-15{fill:#fff}.illustration_signups_2_svg__cls-18{clip-path:url(#illustration_signups_2_svg__clip-path-10)}.illustration_signups_2_svg__cls-19{fill:#ff9582}.illustration_signups_2_svg__cls-21{fill:#33006a}.illustration_signups_2_svg__cls-22{clip-path:url(#illustration_signups_2_svg__clip-path-13)}.illustration_signups_2_svg__cls-23{fill:#f2f2f2}.illustration_signups_2_svg__cls-24{clip-path:url(#illustration_signups_2_svg__clip-path-14)}.illustration_signups_2_svg__cls-25{clip-path:url(#illustration_signups_2_svg__clip-path-16)}.illustration_signups_2_svg__cls-26{clip-path:url(#illustration_signups_2_svg__clip-path-18)}.illustration_signups_2_svg__cls-27{fill:#2bbb4e}.illustration_signups_2_svg__cls-28{clip-path:url(#illustration_signups_2_svg__clip-path-20)}.illustration_signups_2_svg__cls-29{clip-path:url(#illustration_signups_2_svg__clip-path-21)}.illustration_signups_2_svg__cls-30{clip-path:url(#illustration_signups_2_svg__clip-path-22)}.illustration_signups_2_svg__cls-31{fill:#d8d8d8}.illustration_signups_2_svg__cls-32{clip-path:url(#illustration_signups_2_svg__clip-path-23)}.illustration_signups_2_svg__cls-33{fill:#878787}.illustration_signups_2_svg__cls-34{clip-path:url(#illustration_signups_2_svg__clip-path-24)}.illustration_signups_2_svg__cls-35{clip-path:url(#illustration_signups_2_svg__clip-path-25)}.illustration_signups_2_svg__cls-36{clip-path:url(#illustration_signups_2_svg__clip-path-26)}.illustration_signups_2_svg__cls-37{clip-path:url(#illustration_signups_2_svg__clip-path-27)}.illustration_signups_2_svg__cls-38{clip-path:url(#illustration_signups_2_svg__clip-path-28)}.illustration_signups_2_svg__cls-39{fill:#13d0bc}.illustration_signups_2_svg__cls-40{clip-path:url(#illustration_signups_2_svg__clip-path-29)}.illustration_signups_2_svg__cls-42{clip-path:url(#illustration_signups_2_svg__clip-path-37)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_signups_2_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_signups_2_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-5",
    d: "M17.96 33h149.51v150H17.96z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M66 0h133v130H66z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M0 90h133v130H0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-10",
    d: "M12.54 44h155.01v128H12.54z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration_signups_2_svg__clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-15",
    d: "M16.54 47.99h147.02V168H16.54z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration_signups_2_svg__clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration_signups_2_svg__clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M101.9 37.52h63.91v142.46H101.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-18",
    clipPath: "url(#illustration_signups_2_svg__clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-21",
    transform: "rotate(-40 140.278 146.314)",
    d: "M63.92 84.68h134v132h-134z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-23",
    d: "M16.54 47.99h147.02v15.24H16.54z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M20.28 49.49h12.25v12.25H20.28z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M24.77 49.49h12.25v12.25H24.77z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-27",
    d: "M29.27 49.49h12.25v12.25H29.27z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-5",
    d: "M36.58 137.16h44.96v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M24.67 64.07h17.15v17.15H24.67z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 73.6H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 65.66h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 88.7h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 114.12h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 97.44H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 120.48H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-39",
    d: "M62.96 151h56v56h-56z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-15",
    d: "M76.96 166h29v25h-29z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-5",
    d: "M17.96 33h149.51v150H17.96z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M66 0h133v130H66z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M0 90h133v130H0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-10",
    d: "M12.54 44h155.01v128H12.54z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration_signups_2_svg__clip-path-35)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-15",
    d: "M16.54 47.99h147.02V168H16.54z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration_signups_2_svg__clip-path-38)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M97.96 53h66v115h-66z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-42",
    clipPath: "url(#illustration_signups_2_svg__clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-21",
    transform: "rotate(-49 143.115 144.152)",
    d: "M73.63 81.14h123v132h-123z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-14",
    clipPath: "url(#illustration_signups_2_svg__clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-21",
    transform: "rotate(-49 133.1 76.928)",
    d: "M110.61 64.41h29v31h-29z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-23",
    d: "M16.54 47.99h147.02v15.24H16.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M20.28 49.49h12.25v12.25H20.28z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-7",
    d: "M24.77 49.49h12.25v12.25H24.77z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-27",
    d: "M29.27 49.49h12.25v12.25H29.27z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-5",
    d: "M36.58 137.16h44.96v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-19",
    d: "M24.67 64.07h17.15v17.15H24.67z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 73.6H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 65.66h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 88.7h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-33",
    d: "M35.79 114.12h41.78v12.38H35.79z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 97.44H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-31",
    d: "M36.58 120.48H87.1v17.15H36.58z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-39",
    d: "M62.96 151h56v56h-56z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "illustration_signups_2_svg__cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "illustration_signups_2_svg__cls-15",
    d: "M76.96 166h29v25h-29z"
  }))))));
}

export default __webpack_public_path__ + "static/illustration_signups_2.5c7ca791.svg";
export { SvgIllustrationSignups2 as ReactComponent };